import { useState } from "react";

const NotificacionText = ({ notification }) => {
	const [showMore, setShowMore] = useState(false);

	return (
		<div>
			{!showMore ? (
				<div>
					{notification.description.substring(55, -1)}{" "}
					{notification.description.length > 55 && (
						<span style={{ cursor: "pointer", color: "#81ba43" }} onClick={() => setShowMore(!showMore)}>
							Ver más...
						</span>
					)}
				</div>
			) : (
				<div>
					<div
						dangerouslySetInnerHTML={{
							__html: notification.description,
						}}
					></div>

					<span style={{ cursor: "pointer", color: "#81ba43" }} onClick={() => setShowMore(!showMore)}>
						Ver menos...
					</span>
				</div>
			)}
		</div>
	);
};

export default NotificacionText;
